import React, { useRef } from "react";
import { List, ListItem, Region, Section, SubReport, TOC, TableCell } from "../core/pdf/types";
import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";


export function TOCEditor(props: {
	toc: TOC,
}) {

	const designer = useDesigner();

	const toc = props.toc;

	let style: any = {};
	style.width = "210mm";
	style.position = "relative";
	
	const elementContext = useElementContext(toc);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	return (
		<ElementContext.Provider value={elementContext}>
			<div
				className={"toc content-element " + state.classes}
				data-key={toc.id}
				id={state.elementID}

				style={style}

				onClick={(e) => {
					designer.setFocus(toc);
				}}				
			>
				<div className="flex horiz align-center gap-20 padding-5">
					<div className="flex vert gap-5 align-start">
						<b className="text-brand-secondary">Table of Contents</b>
						<p><i>This is automatically generated for each pdf</i></p>
					</div>
				</div>

				{/* <ContentItems
					content={section.content}
				/> */}

			</div>
		</ElementContext.Provider>
	);
}

